var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgArrowRight = function SvgArrowRight(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.53 6.53a.75.75 0 0 0 0-1.06L11.757.697a.75.75 0 0 0-1.06 1.06L14.939 6l-4.242 4.243a.75.75 0 0 0 1.06 1.06L16.53 6.53ZM0 6.75h16v-1.5H0v1.5Z",
    fill: "#161616"
  })));
};

export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNyAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjUzMDMgNi41MzAzM0MxNi44MjMyIDYuMjM3NDQgMTYuODIzMiA1Ljc2MjU2IDE2LjUzMDMgNS40Njk2N0wxMS43NTc0IDAuNjk2Njk4QzExLjQ2NDUgMC40MDM4MDUgMTAuOTg5NiAwLjQwMzgwNSAxMC42OTY3IDAuNjk2Njk4QzEwLjQwMzggMC45ODk1OTIgMTAuNDAzOCAxLjQ2NDQ3IDEwLjY5NjcgMS43NTczNkwxNC45MzkzIDZMMTAuNjk2NyAxMC4yNDI2QzEwLjQwMzggMTAuNTM1NSAxMC40MDM4IDExLjAxMDQgMTAuNjk2NyAxMS4zMDMzQzEwLjk4OTYgMTEuNTk2MiAxMS40NjQ1IDExLjU5NjIgMTEuNzU3NCAxMS4zMDMzTDE2LjUzMDMgNi41MzAzM1pNNi41NTY3ZS0wOCA2Ljc1TDE2IDYuNzVMMTYgNS4yNUwtNi41NTY3ZS0wOCA1LjI1TDYuNTU2N2UtMDggNi43NVoiIGZpbGw9IiMxNjE2MTYiLz4KPC9zdmc+Cg==";